import React from "react";
import Item from "./Item";

// eslint-disable-next-line require-await
var rehydrator = function rehydrator(domNode) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var readData = function readData(prop) {
    var data = domNode.getAttribute("data-".concat(prop));
    return data ? JSON.parse(data) : null;
  };

  var props = {
    active: readData("active"),
    href: readData("href"),
    title: readData("title"),
    ariaLabel: readData("ariaLabel")
  };
  return Promise.resolve( /*#__PURE__*/React.createElement(Item, props));
};

export default rehydrator;